
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { RefreshCw, Minus, Brain, Maximize, Minimize } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ScenarioType } from "@/types/analysis";

interface AnalysisHeaderProps {
  isAnalyzing: boolean;
  hasResult: boolean;
  isMinimized: boolean;
  onRerunAnalysis: () => void;
  onClose: () => void;
  onToggleMinimize: () => void;
  isGuideMode?: boolean;
  onToggleGuideMode?: () => void;
  activeScenario?: ScenarioType | null;
  isExpanded?: boolean;
  onToggleExpand?: () => void;
}

export const AnalysisHeader = ({
  isAnalyzing,
  hasResult,
  onRerunAnalysis,
  onClose,
  isGuideMode = false,
  activeScenario,
  isExpanded = false,
  onToggleExpand
}: AnalysisHeaderProps) => {
  return (
    <div className="p-2.5 flex items-center justify-between bg-indigo-500/90 backdrop-blur-md text-white rounded-t-xl border-b border-indigo-600/70 relative">
      <div className="flex items-center gap-1.5">
        <div className="bg-white/20 p-1.5 rounded-full">
          <Brain className="h-3.5 w-3.5 text-white" />
        </div>
        <h3 className="text-sm font-medium">
          Second Opinion
        </h3>
        {hasResult && !isAnalyzing && !isGuideMode && (
          <TooltipProvider delayDuration={300}>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button 
                  variant="ghost" 
                  size="icon" 
                  onClick={onRerunAnalysis} 
                  disabled={isAnalyzing} 
                  className="h-6 w-6 rounded-full text-white/80 hover:text-white hover:bg-white/10"
                >
                  <RefreshCw className="h-3 w-3" />
                </Button>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="text-xs">
                Rerun Analysis
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      <div className="flex items-center gap-1">
        {onToggleExpand && (
          <TooltipProvider delayDuration={300}>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button 
                  variant="ghost" 
                  size="icon" 
                  onClick={onToggleExpand} 
                  className="h-6 w-6 rounded-full text-white/80 hover:text-white hover:bg-white/10"
                >
                  {isExpanded ? (
                    <Minimize className="h-3 w-3" />
                  ) : (
                    <Maximize className="h-3 w-3" />
                  )}
                </Button>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="text-xs">
                {isExpanded ? 'Collapse' : 'Expand'}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
        <TooltipProvider delayDuration={300}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button 
                variant="ghost" 
                size="icon" 
                onClick={onClose} 
                className="h-6 w-6 rounded-full text-white/80 hover:text-white hover:bg-white/10"
              >
                <Minus className="h-3 w-3" />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="bottom" className="text-xs">
              Close
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
};
